;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { PRODUCTION_APP_ENV_STRING } from "@/lib/constants";

const TEST_TOKEN = 'when-course-human-events';

export function isValidDevMembershipToken(token: string) {
  if(process.env.NODE_ENV === 'development' || process.env.APP_ENV !== PRODUCTION_APP_ENV_STRING) {
    return token.toLowerCase() === TEST_TOKEN
  }

  return false
}
